import React, { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";

/**
 * Static/read-only table for the Base and Heat Factors Report.
 * Receives already-filtered data from the parent page — this component
 * does not fetch or filter anything itself.
 */
const BaseAndHeatFactorsReportList = ({ data = [] }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "AccountNumber",
        header: "Account Number",
        size: 180,
      },
      {
        accessorKey: "RateCategory",
        header: "Rate Category",
        size: 160,
      },
      {
        accessorKey: "InstallationNumber",
        header: "Installation Number",
        size: 220,
      },
      {
        accessorKey: "EntryValue",
        header: "Entry Value",
        size: 160,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value === null || value === undefined ? "-" : value;
        },
      },
      {
        accessorKey: "Operand",
        header: "Operand",
        size: 140,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value === null || value === undefined ? "-" : value;
        },
      },
      {
        accessorKey: "ValidFrom",
        header: "Valid From",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? dayjs(value).format("MM/DD/YYYY") : "-";
        },
      },
      {
        accessorKey: "ValidTo",
        header: "Valid To",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? dayjs(value).format("MM/DD/YYYY") : "-";
        },
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableHiding: false,
    enableExpandAll: false,
    enableRowActions: false,
    enableRowSelection: false,
    enableColumnActions: false,
    enableFullScreenToggle: false,
    autoResetPageIndex: false,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "none",
    renderEmptyRowsFallback: () => (
      <Typography sx={{ padding: 3, textAlign: "center", fontStyle: "italic" }}>
        No results found for the provided search criteria.
      </Typography>
    ),
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#0F3557",
        color: "white",
        fontWeight: "bold",
        textAlign: "center",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        textAlign: "center !important",
      },
    },
    getRowId: (originalRow) => `${originalRow?.AccountNumber}-${originalRow?.Operand}-${originalRow?.ValidFrom}`,
  });

  return (
    <Box id="base-heat-factor-table-container">
      <MaterialReactTable table={table} />
    </Box>
  );
};

export default BaseAndHeatFactorsReportList;